import classNames from 'classnames';
import type { MouseEventHandler } from 'react';

import { Text } from '@revelio/ui';

import styles from './chart-status.module.css';

export const ChartError = ({
  message,
  onClick,
}: {
  message?: string;
  onClick?: MouseEventHandler<HTMLDivElement>;
}) => {
  return (
    <div
      className={classNames(styles.statusPanel, styles.statusPanelClipped)}
      onClick={onClick}
    >
      <Text weight="bold" className={styles.statusTitle}>
        Data Unavailable
      </Text>
      {message ? (
        <Text fontSize="sm" lineClamp={3} className={styles.statusDetail}>
          {message}
        </Text>
      ) : (
        <Text lineClamp={3} className={styles.statusBody}>
          Our team has been notified and is working on a fix. Please try again
          in about an hour.
        </Text>
      )}
    </div>
  );
};
